import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, isRef as _isRef, createVNode as _createVNode, createStaticVNode as _createStaticVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6d7659c9"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createStaticVNode("<header data-v-6d7659c9><h1 class=\"app-header__title\" data-v-6d7659c9><span class=\"primary-text\" data-v-6d7659c9>Splashed</span>  <span class=\"primary-outlined\" data-v-6d7659c9>Unsplash</span></h1><p class=\"app-header__source\" data-v-6d7659c9> Check the <a class=\"primary-link\" target=\"_blank\" href=\"https://github.com/hqcasanova/unsplash\" data-v-6d7659c9> source here </a></p></header>", 1)
const _hoisted_2 = { class: "app-header__nav app-header__nav--sticky" }

import BaseSearch from '@/components/ui/BaseSearch.vue';
import useSearch from '@/composables/useSearch';
import { watch } from 'vue';

export type Props = {
  initQuery?: string,
}


export default /*#__PURE__*/_defineComponent({
  __name: 'AppHeader',
  props: {
    initQuery: { default: '' }
  },
  setup(__props: any) {

const props = __props;


const {
  firstPage,
  query,
  error,
  isLoading,
} = useSearch(props.initQuery);

watch(query, firstPage);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: _normalizeClass(['app-header__progress', {'app-header__progress--loading': _unref(isLoading)}])
    }, null, 2),
    _hoisted_1,
    _createElementVNode("nav", _hoisted_2, [
      _createVNode(BaseSearch, {
        modelValue: _unref(query),
        "onUpdate:modelValue": [
          _cache[0] || (_cache[0] = ($event: any) => (_isRef(query) ? (query).value = $event : null)),
          _cache[1] || (_cache[1] = ($event: any) => (_unref(error) && _unref(firstPage)()))
        ],
        class: "app-header__search rounded white-bg",
        placeholder: "Search for photos..."
      }, null, 8, ["modelValue"])
    ])
  ], 64))
}
}

})